import { useQuery } from '@tanstack/react-query'

import type { BookingSessionResponse } from '../../types/booking-session.js'

import { apiClient } from '../../lib/client.js'
import { bookingSessionKeys } from './keys.js'

export const useGetBookingSession = (
  sessionId: string | undefined,
  {
    throwOnError = false,
  }: {
    throwOnError?: boolean
  }
) =>
  useQuery({
    enabled: !!sessionId,
    queryFn: async () => {
      const response = await apiClient.client.get<BookingSessionResponse>(
        `/booking-session/${sessionId}`
      )
      return response.data
    },
    queryKey: sessionId ? bookingSessionKeys.detail(sessionId) : bookingSessionKeys.all,
    retry: false,
    throwOnError,
  })
